import type { Routes } from '@angular/router';

export const MESSAGE_TEMPLATES_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/templates/views/message-templates/message-templates.component').then((m) => m.MessageTemplatesComponent),
    },
];
